import { refreshTokenWrapper } from 'api/axiosClient';
import API_MAP from 'constants/api';
import { TYPE_FILES } from 'constants/files';
import { getAccessToken, getRefreshToken } from 'utils/cookies';

/**
 * function convert name of file
 * @param {string} name
 * @returns {string} name of file
 */
const convertNameFile = (name) => {
    return name.length > 32 ? name.slice(0, 15) + '...' + name.slice(name.length - 14, name.length) : name;
};

/**
 * function caculator the total size of files
 * @param {Array} files
 * @returns {number} total size of files
 */
const totalSizeFiles = (files) => {
    return files.reduce((total, current) => total + current.size, 0);
};

/**
 * function convert type of file
 * @param {string} type
 * @returns {string}
 */
const convertTypeFile = (type) => {
    let _type = type.substring(type.lastIndexOf('.') + 1);
    switch (_type.toLocaleLowerCase()) {
        case 'rar':
        case 'zip':
        case '7z':
            return TYPE_FILES.COMPRESS;
        case 'xlsx':
        case 'xls':
            return TYPE_FILES.EXCEL;
        case 'jpeg':
        case 'jpg':
        case 'png':
        case 'gif':
        case 'svg':
        case 'xml':
            return TYPE_FILES.IMAGE;
        case 'mp4':
            return TYPE_FILES.VIDEO;
        case 'pdf':
            return TYPE_FILES.PDF;
        case 'doc':
        case 'docx':
            return TYPE_FILES.WORD;
        case 'ppt':
        case 'pptx':
            return TYPE_FILES.POWERPOINT;
        case 'txt':
            return TYPE_FILES.TEXT;
        case 'mp3':
            return TYPE_FILES.SOUND;
        default:
            return 'none';
    }
};

const isXLSXFile = (type) => {
    let _type = type.substring(type.lastIndexOf('.') + 1);
    return _type.toLocaleLowerCase() === 'xlsx'
}

/**
 * function download file
 * @param {object} file
 */
const downloadFile = async (roomId, file) => {
    await refreshTokenWrapper(getRefreshToken(), false)
    const link = document.createElement('a');
    link.href = `${API_MAP.DOWNLOAD_FILE}?fileId=${file.id}&roomId=${roomId}&token=${getAccessToken()}`;
    link.download = file.name;

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
};

/**
 * function download all files
 * @param {object} files
 */
const downloadAllFiles = async (roomId, isDownloadSubs = false, liveCaptionsId, type) => {
    try {
        const link = document.createElement('a');
        if(isDownloadSubs){
            link.href = `${API_MAP.EXPORT_FILE_SUB}${type}?liveCaptionsId=${liveCaptionsId}&token=${getAccessToken()}`;
        } else {
            link.href = `${API_MAP.DOWNLOADS_ALL_FILE}${roomId}?token=${getAccessToken()}`;
        }
        link.download = roomId;

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link)
    } catch (error) {
        console.log('error', error);
    }
};

export { convertNameFile, convertTypeFile, downloadAllFiles, downloadFile, isXLSXFile, totalSizeFiles };
